import { api } from '../api';

/**
 * 보이스웰니스 오늘 현황 클라이언트
 */

export interface VoiceTodaySummary {
  date: string;
  source: 'cache' | 'live' | 'empty';
  hasData: boolean;
  testId: number | null;
}

export interface VoiceScoreCard {
  type: 'hearing' | 'cognitive' | 'stress';
  label: string;
  todayScore: number | null;
  yesterdayScore: number | null;
  status: string | null;
  deltaPct: number | null;
  dropped: boolean;
}

export interface VoiceTodayDetail {
  /** voicecheck 매핑 — 미연결 알림 판정에 resident.voiceUserId보다 우선 */
  voiceUserId: number | null;
  summary: VoiceTodaySummary;
  scores: VoiceScoreCard[];
}

/**
 * 보이스웰니스 오늘 현황 조회
 * @returns {Promise<VoiceTodayDetail>}
 */
export async function getResidentVoiceToday(
  residentId: string,
  date?: string,
): Promise<VoiceTodayDetail> {
  const res = await api.get<VoiceTodayDetail>(`/residents/${residentId}/voice/today`, {
    params: date ? { date } : undefined,
  });
  return res.data;
}
